import { routingMixins } from "@/mixins/routing";
import { dialogMixins } from "@/mixins/dialog";
import { throbberMixins } from "@/mixins/throbber";
import { dateTimeMixins } from "@/mixins/date-time";
import { componentHelperMixins } from "@/mixins/component-helper";
import { formattingMixins } from "@/mixins/formatting";
import { axiosMixin } from "@/mixins/axios";
import { ruleMixins } from "@/mixins/rules";

export { PropertyState } from "@/mixins/component-helper";

const mixins = {
  ...routingMixins,
  ...dialogMixins,
  ...throbberMixins,
  ...dateTimeMixins,
  ...componentHelperMixins,
  ...formattingMixins,
  ...axiosMixin,
  ...ruleMixins,
};

export default mixins;

export const mixinConfig = {
  methods: mixins,
};

export declare interface ArrayWrap<T = any> {
  [key: string]: T;
}
